module.exports = __webpack_public_path__ + "img/back.d94e1174.png";